// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb40d62d","453":"3bb1b859","455":"e1bbc1a8","977":"6a0b79f9"}[chunkId] + ".chunk.js";
};